import { render } from "./GoodsItem.vue?vue&type=template&id=05608735&scoped=true"
import script from "./GoodsItem.vue?vue&type=script&lang=js"
export * from "./GoodsItem.vue?vue&type=script&lang=js"

import "./GoodsItem.vue?vue&type=style&index=0&id=05608735&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05608735"]])

export default __exports__